import {useDebugValue} from 'react';

import {useStore} from './';

const storeDataRef = 'experimentData';
const storeKeysRef = 'experimentNames';

const defaultStore = {
    [storeDataRef]: {},
    [storeKeysRef]: []
};

function useAbacusStore(props) {
    const {
        abacusStore: propsStore
    } = props;

    const {
        store
    } = useStore({storeDataRef, storeKeysRef}, defaultStore, propsStore);

    const result = {
        store
    };

    useDebugValue(result);

    return result;
}

export {useAbacusStore};
